<div class="form-container"  *ngIf="assetGetDataFronAnotherCoponent.assetId==null">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">Add Asset </div>
      </ion-col>

      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!-- authority-form.component.html -->
    <form [formGroup]="assetForm" style="margin: 10px;">
      <ion-row>
       <ion-col size="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Asset Name<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="assetName" placeholder="" />
            <mat-error *ngIf="hasError('assetName', 'required')">Asset is required</mat-error>
          </mat-form-field>
        </ion-col>

     
        <ion-col size="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Allocating Department<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select band ..." formControlName="allocatingDep"
              (selectionChange)="onEmployeeChange($event)">
              <mat-option [value]="item.assetAuthorityId" *ngFor="let item of autorityListData" class="custom-option">
                {{ item.assetDepartmentName}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="hasError('allocatingDep', 'required')">Allocating Department is required</mat-error>
          </mat-form-field>
        </ion-col>

        <!-- Limit of Reimbursement -->
        <ion-col size="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">Authority Name<span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="employeeName" readonly />
          </mat-form-field>
          <mat-error *ngIf="hasError('employeeName', 'required')">EmployeeName is required</mat-error>
        </ion-col>
  
        <ion-col size="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Band<span class="red-cl">&nbsp;*</span>
          </div>
          
<!--   <mat-form-field appearance="outline" class="w-100 mat-height40" style="margin-top: 10px">
    <mat-label class="centered-label">Select Finance Admin</mat-label>
    <mat-select [(ngModel)]="selectedEmployee" name="reimbursementSelect" multiple>
      <mat-option *ngFor="let item of getAllFinanceUserDD" [value]="item.id" (click)="confirmSelection(item, $event)"
        [disabled]="allreadySellectedFinanceAdmin.includes(item.id) && reimbursementTable.length>0">
        {{ item.firstName }} {{ item.lastName }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->

          <ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Department'"
          [settings]="dropdownSettings"  [(ngModel)]="selectedBandsList" [data]="allListingband" formControlName="band"
          (onSelect)="onBandSelect($event)"
          (onDeSelect)="onBandDeselect($event)"
          (onSelectAll)="selectAllDept($event)" (onDeSelectAll)="onDeSelectAllDept()"></ng-multiselect-dropdown>

       <!--<ng-multiselect-dropdown class="d-flex" [placeholder]="'Select Department'" [settings]="dropdownSettings"
            [data]="allListingband" [(ngModel)]="preSelectedBandItems" (onSelect)="getBandList()" (onDeSelect)="getBandList()"
            (onSelectAll)="selectAllDept($event)" (onDeSelectAll)="onDeSelectAllDept()">
          </ng-multiselect-dropdown> -->

          

          <mat-error *ngIf="hasError('band', 'required')">Band is required</mat-error>
        </ion-col>

      </ion-row>

      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="cancelbutton()">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"[class.disabled]="assetForm.invalid"
            (click)="assetGetDataFronAnotherCoponent.operation=='Add'?saveassetData():updateAsset()">
           {{assetGetDataFronAnotherCoponent.operation=='Add'?'Add':'Update'}}
          </button>
        </ion-col>
      </ion-row>
    </form>

  </div>
</div>


  <div class="tabs-container">
    <div *ngIf="assetGetDataFronAnotherCoponent.assetId!=null" style="margin: 20px !important;">





      <table class="table table-bordered laptopAllocation">
        <thead>
          <tr>
            <th></th>
            <th>Asset Name</th>
            <th>Band</th>
            <th>Authority Name </th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let asset of allocatingEmployee">
            <tr>
              <td style="width: 2px;" (click)="asset.isExpand = !asset.isExpand">

                <mat-icon *ngIf="!asset.isExpand" style="width:30px">expand_more</mat-icon>
                <mat-icon *ngIf="asset.isExpand" style="width:30px">expand_less</mat-icon>
              </td>
              <td style="cursor: pointer !important;  color: #143E8E;">
                {{ asset.assetName }}</td>
              <td>{{ asset.band }}</td>
              <td>{{asset.allocatingAuthorityName}}</td>

            </tr>

            <!-- Expanded Row: Display details related to multiple users -->
            <tr *ngIf="asset.isExpand">
              <td colspan="4">
                <table class="table table-sm insideTable">
                  <thead>
                    <tr>
                      <th>Employee Name</th>
                      <th>Band</th>
                      <th>Authority Dept</th>
                      <th>Authority Name</th>
                      <th>Allocation Date</th>
                      <th>Current Asset Description</th>
                      <th>Employee Status</th>
                      <th>Employee Comment</th>
                      <th>Employee Comment Date</th>
                      <th>Authority Department Comment</th>
                      <th>Authority Comment Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let user of asset?.users; let i = index" class="insideTable">
                      <td style="cursor: pointer !important;  color: #143E8E;">{{
                        user.employeeName }}</td>
                      <td>{{user.band}}</td>
                      <td>{{ user.allocatingAuthorityDept }}</td>
                      <td>{{ user.allocatingAuthorityName }}</td>
                      <td>{{ user.dateOfAllocation }}</td>
                      <td>{{user.currentAssetDescription}}</td>
                      <td>{{user.employeeAssetStatus}}</td>
                      <!-- <td>
                        <mat-form-field class="w-100 mat-height40 mat-input-style">

                          <mat-select [(ngModel)]="user.employeeAssetStatus" name="authorityDepartmentComment"
                            >
                            <mat-option *ngFor="let option of assetOptions" [value]="option">
                              {{ option }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </td> -->
                      <td>{{ user.employeeComment || 'No comment' }}</td>
                      <!-- <td>
                        <textarea rows="2" [(ngModel)]="user.employeeComment" cols="4" class="edittextarea"
                          maxlength="255"  placeholder="comment....">
                              </textarea>
                      </td> -->
                      <td>{{ user.employeeCommentDate }}</td>
                      <td>{{ user.authorityDepartmentComment }}</td>
                      <td>{{user.authorityCommentDate}}</td>

                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>









    </div>
  </div>
